import request from '@Sys~/api/request'
import { apiUrl } from './env'
import store from '@Sys~/store'

const fileUrl = apiUrl.fileUrl

// 配置接口 公共项
function configAjax(url,method,data) {
    return request({
        headers: {
            "cemial": store.getters.email,
        },
        baseURL: fileUrl,
        url: url,
        method: method ? method : 'post',
        data: data,
        withCredentials: false
    })
}

// 查询接口 公共项
function searchAjax(url,data,method) {
    return request({
        headers: {
            "cemial": store.getters.email,
            "Cname":  encodeURI(store.getters.userInfo.realname)
        },
        baseURL: fileUrl,
        url: url,
        method: method ? method : 'post',
        data: data,
        withCredentials: false
    })
}



// 外包部门列表
export function config_departmentList() {
    return searchAjax('/api/config/departmentList?roleIds='+ store.getters.roles) 
}

// 设计类型树
export function config_designTypeTree() {
    return searchAjax('/api/config/designTypeTree') 
}

// 外包商列表
export function config_outsourceList(type) {
    return searchAjax('/api/config/outsourcerList?type='+type+'&roleIds='+store.getters.roles) 
}

// 查询菜单 id 集合 对应 的文件夹
export function config_folderByMenuIds(MenuArr) {
    return searchAjax('/api/config/folderByMenuIds',MenuArr) 
}

// 父级Id 查询 子级 文件列表
export function config_folderByPid(folderPid) {
    return searchAjax('/api/config/folderByPid?folderPid='+folderPid) 
}

// 新增
export function outsource_addFlow(data) {
    return configAjax('/api/outsource/addFlow','post',data) 
}


// 任务大盘（各个状态工单总数）
export function outsource_flowStatusNum(data) {
    return searchAjax('/api/outsource/flowStatusNum?roleIds='+store.getters.roles.join(',')) 
}

// 工单列表
export function outsource_flowList(data) {
    return searchAjax('/api/outsource/flowList',data) 
}


// 工单详情
export function outsource_flowDetail(data) {
    return searchAjax('/api/outsource/flowDetail?flowId='+data) 
}

// 外包工单迭代详情（流程图）
export function outsource_flowLogList(data) {
    return searchAjax('/api/outsource/flowLogList?flowId='+data) 
}

// 需求变更
export function outsource_modifyFlow(data) {
    return configAjax('/api/outsource/modifyFlow','post',data) 
}

// 保存完稿文件
export function outsource_saveCompleteFile(data) {
    return configAjax('/api/outsource/saveCompleteFile','post',data) 
}

// 修改工单状态
export function outsource_flowModifyStatus(data) {
    return configAjax('/api/outsource/flowModifyStatus','post',data) 
}

// 保存结算单、验收单文件
export function outsource_saveAcceptanceFile(data) {
    return configAjax('/api/outsource/saveAcceptanceFile','post',data) 
}

// 外包商标签
export function config_outsourcerLabel(data) {
    return searchAjax('/api/config/outsourcerLabel?type='+data) 
}

// 外包商列表
export function outsource_outsourcerList(data) {
    return searchAjax('/api/outsource/outsourcerList',data) 
}

// 保存外包商
export function outsource_saveOutsourcer(data) {
    return configAjax('/api/outsource/saveOutsourcer','post',data) 
}

// 删除外包商
export function outsource_deleteOutsourcer(data) {
    return configAjax('/api/outsource/deleteOutsourcer?id='+data,'post') 
}